import clsx from "clsx";
import { HTMLAttributes } from "react";

type InfoCardProps = {
    children: React.ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const InfoCard = ({ children, className, ...props }: InfoCardProps) => {
    return (
        <div
            className={clsx("rounded-lg border text-sm", className)}
            {...props}
        >
            {children}
        </div>
    );
};

export default InfoCard;
